import { ResolveFn } from '@angular/router';
import { ApplicationFormDetails } from '../../../../shared/models/application-form-details';
import { inject } from '@angular/core';
import { ApplicationFormsApi } from '../../../../shared/services/api/application-forms.api';

export const applicationFormDetailsResolver: ResolveFn<
  ApplicationFormDetails
> = (route) => {
  const api = inject(ApplicationFormsApi);
  const parsedId = Number(route.paramMap.get('id'));

  return api.getApplicationFormDetails$(parsedId);
};
